import {Link} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Sidebar from './sidebar';
import React,{ useState,useEffect,useContext } from 'react';
import api from "../api";
import { ExchangeRateContext } from '../../ExchangeRateContext';
import { FaCheck, FaCheckCircle, FaTag } from 'react-icons/fa';
import useStoreSetupCheck from './useStoreSetupCheck';
import { Percent, Trash2 } from 'react-feather';
function SellerProductsOffers(){    
    const setupStatus = useStoreSetupCheck();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl0 = process.env.REACT_APP_BASE_URL_IMG;
    const [ProductData, setProductData] = useState([]);
    const [productImgs, setProductImgs] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOption, setSortOption] = useState("default"); 
    const [error, setError] = useState("");
    const [DelId, setDelId] = useState("");
    const [DelIdStatus, setDelIdStatus] = useState(false);
    const [offerStatus, setofferStatus] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [discount, setDiscount] = useState(0);
    const [discountError, setDiscountError] = useState(false);
    const [clearStatus, setClearStatus] = useState(""); 

    const toggleProductSelection = (productId) => {
        setSelectedProducts(prev =>
            prev.includes(productId) ? prev.filter(id => id !== productId) : [...prev, productId]
        );
    };

  
    const { exchangeRates, baseCurrency } = useContext(ExchangeRateContext);
    const token = localStorage.getItem("access_token");
    const fetchVendorProducts = async () => {
        try {
            const response = await api.get("/vendor-products/", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = response.data.results;
            setProductData(data.products);
            // Optional: if you want images
            // setProductImgs(data.products.map(p => p.product_imgs));
        } catch (error) {
            //console.error("Error fetching products:", error);
        }
    };

    
    useEffect(() => {
        fetchVendorProducts();
    }, []);

    function deleteStepOne(product){
        setDelId(product);
        setDelIdStatus(false);
      }
      function handleDelete(){
          api.delete(baseUrl+'/product/'+DelId+'/', {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then(function (response){
            //console.log(response.status);
              if(response.status==204){
                  fetchVendorProducts();
                  setDelIdStatus(true);
              }
          })
          .catch(function(error){
              //console.log(error);
          });
      }

    // Filter and Sort Products
    const filteredAndSortedResults = (ProductData || [])
    .filter((product) => {
        const search = searchTerm.toLowerCase();
        return (
        (product.title && product.title.toLowerCase().includes(search)) ||
        (product.price && product.price.toString().toLowerCase().includes(search))
        );
    })
    .sort((a, b) => {
        const aHasDiscount = a.offer_price > a.price;
        const bHasDiscount = b.offer_price > b.price;

        if (aHasDiscount && !bHasDiscount) return -1;
        if (!aHasDiscount && bHasDiscount) return 1;

        if (sortOption === "price_high_low") return b.price - a.price;
        if (sortOption === "price_low_high") return a.price - b.price;
        if (sortOption === "qty_high_low") return b.stock - a.stock;
        if (sortOption === "qty_low_high") return a.stock - b.stock;
        if (sortOption === "default") return b.id - a.id;

        return 0;
    });


    
    const getVendorCurrency = () => {
        return localStorage.getItem("VendorCurrency");
    };

    const applyOfferToProducts = async () => {
        if (!discount || discount <= 0) {
            setDiscountError(true);
            setTimeout(() => {
                setDiscountError(false);
            }, 3000);
            return;
        } else {
            setDiscountError(false);
        }

        try {
            const updates = await Promise.all(selectedProducts.map(async (id) => {
                const product = ProductData.find(p => p.id === id);
                const newOfferPrice = Math.round((product.offer_price - (product.offer_price * (discount / 100))));
                return api.patch(`${baseUrl}/product/${id}/`, 
                    { price: newOfferPrice }, 
                    {
                        headers: { Authorization: `Bearer ${token}` }
                    });
            }));

            // Refresh product list
            fetchVendorProducts();
            setSelectedProducts([]);
            setDiscount(0);
            setofferStatus(true);
        } catch (error) {
            //console.error("Failed to apply offer:", error);
            //alert("An error occurred while applying the offer.");
        }
    };
    const clearOffersFromProducts = async () => {
        try {
            await Promise.all(selectedProducts.map(async (id) => {
            const product = ProductData.find(p => p.id === id);
            return api.patch(`${baseUrl}/product/${id}/`, 
                { price: product.offer_price }, // Reset offer price to normal price
                {
                headers: { Authorization: `Bearer ${token}` }
                });
            }));

            // Refresh UI
            fetchVendorProducts();
            setSelectedProducts([]);
            setofferStatus(false);
            setClearStatus("Discounts cleared for the selected products.");
            setTimeout(() => setClearStatus(''), 3000);
        } catch (error) {
            //console.error("Failed to clear discounts:", error);
            //alert("An error occurred while clearing the discounts.");
        }
    };

    return (
        <>                     
            <Helmet>
                <title>Manage Discounts</title>
                <meta name="description" content={`Manage Discounts`} />
            </Helmet>
            <section className="container mtopcon dashb">
                <div className="row">
                    <div className="col-12 col-lg-2 dash-min mb-3">
                            <div className="nav-left-sidebar sidebar-dark pc">
                                <div className="slimScrollDiv" ><div className="menu-list" >
                                    <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                        <a className="d-xl-none d-lg-none" href="#"></a>
                                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                        <div className="collapse navbar-collapse" id="navbarNav">
                                            <Sidebar/>
                                        </div>
                                    </nav>
                                </div><div className="slimScrollBar"></div><div className="slimScrollRail"></div></div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-10 dash-max orderscontainer">     
                            <div className="row mb-4 ph-header-con pt-2">
                                <h6 className="pageheader-title mb-0">Manage Discounts</h6>
                                <p className="grey-text lh0 font8">Create and manage product discounts to boost sales.</p>
                            </div> 
                            <div className="row mb-3">
                                <div className="col-8">
                                    <input
                                        className="filter2 border me-2 w-100"
                                        type="search"
                                        placeholder="Search Products"
                                        aria-label="Search"
                                        onChange={(e) => setSearchTerm(e.target.value)} // Update the search term on keyup
                                    />
                                </div>
                                <div className="col-4">
                                        <select className="filter2 text-center border w-100 h-100" name='category' onChange={(e) => setSortOption(e.target.value)}>
                                            <option value="default">Sort</option>
                                            <option value="price_high_low">Price from High to Low</option>
                                            <option value="price_low_high">Price from Low to High</option>
                                            <option value="qty_high_low">Qty from High to Low</option>
                                            <option value="qty_low_high">Qty from Low to High</option>
                                        </select>
                                </div>
                            </div>

                            <div className="mb-4">
                                    {selectedProducts.length > 0 && (
                                        <>
                                            <div className='col-12 text-right p-2 m-0 bg-blue-gradient mb-3 br-10'>
                                                <button className="btn btn-warning me-2 font9" data-bs-toggle="modal" data-bs-target="#offerModal">
                                                    Create ({selectedProducts.length} selected)
                                                </button>
                                                <button className="btn btn-danger font9" onClick={clearOffersFromProducts}>
                                                    Clear discounts
                                                </button>
                                            </div>
                                        </>
                                    )}
                                    
                                    {clearStatus && <p className="text-success mb-4 mt-4 text-center font-bold">{clearStatus}</p>}

                                    {filteredAndSortedResults.length === 0 ? (
                                        <p>No products yet — add your first one to get started.</p>
                                    ) : (
                                        <>
                                            {filteredAndSortedResults.map((product,index) => (
                                                <div className="row ord-bg bg-white p-2 hvr bx-shadow" key={product.id}>                                                    
                                                        <div className="col-auto p-0 col_selectproduct"><span className="float-left"></span>
                                                            <input
                                                            type="checkbox"
                                                            className="ms-2 selectproduct"
                                                            checked={selectedProducts.includes(product.id)}
                                                            onChange={() => toggleProductSelection(product.id)}
                                                            />

                                                        </div>
                                                        <div className="col-2 col-lg-1 p-0 col_selectproduct"><span className="float-left"></span>
                                                            <div className="ord-img float-left">
                                                            <img src={baseUrl0+product.product_imgs[0].image} className='w-100 h-100' alt='#'/>       
                                                            </div>
                                                        </div>
                                                        <div className="col-6 col-lg-6 pl-0 pr-0">
                                                            <div className="row">
                                                                <div className="col-11 col-lg-5 ord-sz"><Link to={`/product/${product.title}/${product.id}`}>{product.title}</Link></div>
                                                                <div className="col-8 col-lg-5 ord-sz">
                                                                    {
                                                                        <span>{getVendorCurrency()} {Math.round(product.price)}</span>
                                                                    } 
                                                                </div>
                                                                <div className="col-4 col-lg-2 ord-sz grey-text">Qty: {product.stock}</div>
                                                            </div>
                                                        </div>
                                                        <div className="col-2 col-lg-2 f8 text-black text-right p-0 mt-1 lh34">
                                                                {Number(product.offer_price) > Number(product.price) ? (
                                                                    <>
                                                                        <FaTag className='text-success me-1 small-icon-11' />
                                                                        {Math.round(
                                                                        ((Number(product.offer_price) - Number(product.price)) / Number(product.price)) * 100
                                                                        )}%
                                                                    </>
                                                                    ) : (
                                                                    <>
                                                                        <span className="text-muted">#</span>
                                                                    </>
                                                                )}


                                                        </div>
                                                </div>
                                            ))}
                                        </>
                                    )}
                                

                            </div>
                    </div>
                </div>

                <div className="modal fade" id="offerModal" tabIndex="-1" aria-labelledby="offerModalLabel" aria-hidden="true">
                    <div className="modal-dialog mtop_modal">
                        <div className="modal-content">
                            <div className="modal-body">
                                { offerStatus === true ? 
                                
                                <>                                    
                                    <div className="bg-success-nw br50r p-0 text-center text-white" role="alert" style={{ height: "40px", width: "40px", margin: "0 auto" }}>
                                        <FaCheck className='mt-2'/>
                                    </div>
                                    <h2 className="modal-title fw800 text-center mt-2" id="confirmdelModalLabel">Discount Created</h2>
                                    <div className='mb-3 text-center'>Discount applied to selected products successfully.</div>
                                    
                                    <button type="button" className="col-12 btn btn-outline-dark font-bold" data-bs-dismiss="modal">Close</button>
                                </> : <>
                                    <div className="bg-success-nw br50r p-0 text-center text-white" role="alert" style={{ height: "40px", width: "40px", margin: "0 auto" }}>
                                        <Percent className='mt-2'/>
                                    </div>
                                    <h2 className="modal-title fw800 text-center mt-2" id="confirmdelModalLabel">Create Discount</h2>
                                    <div className="form-group mb-2">
                                        <div className='mb-3 text-center'>Select Discount Percentage</div>                                        

                                        <div className="discount-container">

                                            {/* Quick Picks */}
                                            <div className="discount-selector mb-3">
                                                {[5, 10, 15, 20, 25, 30, 40, 50].map((value) => (
                                                    <button
                                                        type="button"
                                                        key={value}
                                                        className={`discount-pill ${
                                                            discount === value ? "active" : ""
                                                        }`}
                                                        onClick={() => setDiscount(value)}
                                                    >
                                                        {value}%
                                                    </button>
                                                ))}
                                            </div>

                                            {/* Custom Value */}
                                            <select
                                                className={`form-select custom-discount ${
                                                    discountError ? "border border-danger" : ""
                                                }`}
                                                value={discount}
                                                onChange={(e) => setDiscount(Number(e.target.value))}
                                            >
                                                <option value="">Custom discount</option>

                                                {[...Array(100)].map((_, i) => (
                                                    <option
                                                        key={i + 1}
                                                        value={i + 1}
                                                    >
                                                        {i + 1}%
                                                    </option>
                                                ))}
                                            </select>

                                            {discount > 0 && (
                                                <div className="discount-preview mt-2">
                                                    Discount: <strong>{discount}% OFF</strong>
                                                </div>
                                            )}

                                        </div>
                                        {discountError && <small className="text-danger text-left">Kindly select a valid discount.</small>}

                                        <div className='mt-4'>
                                            { offerStatus === true ? <>
                                                <button type="button" className="col-12 btn btn-outline-dark font-bold" data-bs-dismiss="modal">Close</button>
                                            </> : <>
                                                {DelIdStatus==false && <><button type="button" className="col-12 btn btn-dark" onClick={applyOfferToProducts}>Apply</button></>}
                                                <button type="button" className="col-12 btn btn-outline-dark font-bold mt-2" data-bs-dismiss="modal">Cancel</button>
                                            </>} 
                                        </div> 
                                    </div>
                                </>}                                
                            </div>
                        </div>
                    </div>
                </div>


            </section>
        </>
    )
}

export default SellerProductsOffers;